<script>
	import UserController from './../controlador/userController.svelte';
	import {replace} from 'svelte-spa-router';
	db = new PouchDB("db");
	let control
	let u = '';
	let p = '';
	async function login(){
		let dato = await control.login(u,p);
		console.log(dato);
		replace(dato.valor);
	}
</script>
<UserController bind:this={control} />

<div class="center">
	<div class="carta">
		<div class="logo">
			<img src="/logo.svg" alt="">
		</div>
		<div class="contenido">
			<input class="input" type="text" placeholder="Cuenta" bind:value={u}>
			<input class="input" type="password" placeholder="Contraseña" bind:value={p}>
			<button class="boton" on:click={login}>Ingresar <i class="ph-arrow-right"></i></button>
		</div>
	</div>
</div>

<style>
	.carta{
		width: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		margin-bottom: 100px;
	}
	.contenido{
		width: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}
	.input{
		border-radius: 10px;
		border: none;
		outline: none;
		height: 30px;
		padding: 5px;
		margin: 5px;
		width: 90%;
    	max-width: 380px;
	}
	.boton{
		display: flex;
		align-items: center;
		justify-content: center;
		margin: 10px;
		padding: 5px;
		background: transparent;
		color: white;
		font-size: 18px;
		border: none;
		outline: none;
		vertical-align: middle;
		cursor: pointer;
	}
	.boton > i{
		margin-top: 5px;
	}
	.center{
		background-color: var(--azul);
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		height: 100vh;
		width: 100vw;
		max-width: 100%;
		max-height: 100%;
	}
	img{
		box-sizing: border-box;
		margin: 0px;
		width: 200px;
		object-fit: cover;
	}
</style>
